var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2383 39.6576C45.2383 40.2543 45.0012 40.8266 44.5793 41.2486C44.1573 41.6705 43.585 41.9076 42.9883 41.9076H6.98828C6.39154 41.9076 5.81925 41.6705 5.39729 41.2486C4.97533 40.8266 4.73828 40.2543 4.73828 39.6576V9.65759C4.73828 9.06086 4.97533 8.48856 5.39729 8.0666C5.81925 7.64465 6.39154 7.40759 6.98828 7.40759C7.58502 7.40759 8.15732 7.64465 8.57927 8.0666C9.00123 8.48856 9.23828 9.06086 9.23828 9.65759V25.6982L17.507 18.4701C17.8952 18.1305 18.3883 17.9345 18.9037 17.9151C19.4191 17.8956 19.9256 18.0538 20.3383 18.3632L30.8795 26.2682L41.507 16.9701C41.7247 16.7528 41.9847 16.5824 42.2709 16.4696C42.557 16.3567 42.8633 16.3037 43.1707 16.3138C43.4781 16.3239 43.7802 16.397 44.0583 16.5285C44.3364 16.66 44.5846 16.8471 44.7875 17.0783C44.9904 17.3095 45.1438 17.5798 45.2381 17.8726C45.3324 18.1654 45.3657 18.4744 45.3359 18.7805C45.3061 19.0867 45.2139 19.3835 45.0649 19.6526C44.9158 19.9217 44.7132 20.1574 44.4695 20.3451L32.4695 30.8451C32.0813 31.1847 31.5883 31.3807 31.0728 31.4001C30.5574 31.4196 30.051 31.2614 29.6383 30.952L19.097 23.0526L9.23828 31.6795V37.4076H42.9883C43.585 37.4076 44.1573 37.6446 44.5793 38.0666C45.0012 38.4886 45.2383 39.0609 45.2383 39.6576Z",
    fill: "url(#paint0_linear_1559_24276)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1559_24276",
    x1: 25.0424,
    y1: 7.40759,
    x2: 25.0424,
    y2: 41.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLine);
export default __webpack_public_path__ + "static/media/ChartLine.5923606c39eef1d36021c079d4115536.svg";
export { ForwardRef as ReactComponent };